import React from "react";
import PageHeader from "../../PageHeader";
import { useLocation } from "react-router-dom";
import FireOnMenu from "../FireOnMenu";

export default function FireAlarmStatisticsTypeComponent(props) {
  const location = useLocation();
  const { buildingName } = location.state;

  return (
    <section id="darkMode" class="mbSection darkMode">
      <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
      <div class="container RTS-container">
        <p class="tableTitle">{props.title} 통계</p>
        <div class="tableList RTSlist">
          <div class="config-row title-row">
            <div class="title-txt">{props.title}</div>
            <div class="month-txt">1월</div>
            <div class="month-txt">2월</div>
            <div class="month-txt">3월</div>
            <div class="month-txt">4월</div>
            <div class="month-txt">5월</div>
            <div class="month-txt">6월</div>
            <div class="month-txt">7월</div>
            <div class="month-txt">8월</div>
            <div class="month-txt">9월</div>
            <div class="month-txt">10월</div>
            <div class="month-txt">11월</div>
            <div class="month-txt">12월</div>
            <div class="total-txt">계</div>
          </div>
          {props.data.map((item, index) => (
            <div class="config-row">
              <div class="title-txt">{item.title}</div>
              {item.months.map((month, monthIndex) => (
                <div class="month-txt">{month}</div>
              ))}
              <div class="total-txt">{item.total}</div>
            </div>
          ))}
        </div>
      </div>
      <FireOnMenu />
    </section>
  );
}
